import { render } from "./companies.vue?vue&type=template&id=307e63c8&scoped=true"
import script from "./companies.vue?vue&type=script&lang=ts"
export * from "./companies.vue?vue&type=script&lang=ts"

import "./companies.vue?vue&type=style&index=0&id=307e63c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-307e63c8"

export default script